export default {
  sendMessagePlaceholder: 'Send message to the hunting team',
  readMessagesErrorMessage: 'Unable to load all messages. Please try again.',
  sendMessageErrorMessage: 'An error occurred and the message could not be sent. Please try again.'
}
